

export function render(data, config){
    const datatable = $(`#table`).DataTable(); 

    $( datatable.column(1).header()).text( `${config.axis.x.label}` );
    $( datatable.column(2).header()).text( `${config.axis.y.label}` );
    datatable.clear()
    //.destroy()
    datatable.rows.add(data).draw();

}
// export function update(data){

// }
export function filterColumn(value){
    const dTable = $(`#table`).DataTable(); 
    dTable.columns(0).search(`^${value}$`,true,false).draw();
}

export function clearColumnFilter(){    
    const dTable = $(`#table`).DataTable(); 
    dTable.column(0).search("").draw();
    $('tr').removeClass('click')
}